import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { PaginatedResponse } from "@/shared/http";

import { CollectionChangeRecord } from "../CollectionRecord";

import { collectionQueryKeys } from "./collectionQueryKeys";

export function getQueryKey(collectionId: string | undefined) {
  return collectionQueryKeys.changes(collectionId);
}

export function useCollectionChanges(collectionId: string | undefined) {
  const { collections } = useDomainServices();

  return useInfiniteQuery({
    queryKey: getQueryKey(collectionId),
    queryFn: ({ pageParam, signal }) =>
      collections.listChanges(collectionId!, {
        pageToken: pageParam,
        abortSignal: signal,
      }),
    select: (data) =>
      data.pages.flatMap(
        (page: PaginatedResponse<CollectionChangeRecord>) => page.items,
      ),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage: PaginatedResponse<CollectionChangeRecord>) =>
      lastPage.next_token ?? undefined,
    enabled: collectionId !== undefined,
    placeholderData: keepPreviousData,
  });
}
